// Nomes das seções de configuração de uma escala. Única fonte de verdade para as
// etapas do wizard Criar escala (CreateSchedule + título de cada etapa) e as abas
// do Editar escala (EditScheduleModal), para que os dois fluxos usem o mesmo nome.

export const SCHEDULE_SECTION_LABELS = {
  basicInfo: 'Informações básicas',
  requirements: 'Requisitos da escala',
  exchangeConfig: 'Trocas e jornada',
  attendancePolicy: 'Política de registro de plantão',
  exceptionality: 'Excepcionalidade',
  paymentPolicy: 'Política de pagamento'
} as const
